jQuery(document).ready(function( $ ){
	// START JQUERY

	logit = (typeof logit !== 'undefined')? logit : false;
	main_navbar = (typeof main_navbar !== 'undefined')? main_navbar :  'mainNavbar';
	browserName = (typeof browserName !== 'undefined')? browserName :  '';

//	videoloop_enable = false;
//	videofix_autoplay_enable = true;

//	videoloop_id = "videoloop-player";
//	videoloop_skip_last =  0; // sec 1
//	videoloop_skip_first = 0; // sec 1
//	videofix_autoplay_target = videoloop_id;
//	videofix_autoplay_click_id = main_navbar;

	videoloop_enable = (typeof videoloop_enable !== 'undefined')? videoloop_enable : false;
	videoloop_id = (typeof videoloop_id !== 'undefined')? videoloop_id : "videoloop-player";
	videoloop_skip_last = (typeof videoloop_skip_last !== 'undefined')? videoloop_skip_last :  0; // sec 1
	videoloop_skip_first = (typeof videoloop_skip_first !== 'undefined')? videoloop_skip_first :  0;

	videofix_autoplay_enable = (typeof videofix_autoplay_enable !== 'undefined')? videofix_autoplay_enable :  true;
	videofix_autoplay_target = (typeof videofix_autoplay_target !== 'undefined')? videofix_autoplay_target :  videoloop_id;
	videofix_autoplay_click_id = (typeof videofix_autoplay_click_id !== 'undefined')? videofix_autoplay_click_id :  main_navbar;

	if(videoloop_enable && videoloop_id) {
		if(logit) console.log('[VIDEO LOOP] Enabled: ' + videoloop_id);
		if(logit == 2) console.log('[VIDEO LOOP] Skip first: ' + videoloop_skip_first + ', last: ' + videoloop_skip_last + ' s.');

		var videoloop = document.getElementById(videoloop_id);
		if(videoloop) {
				var videoloop_duration = videoloop.duration;
				if(logit == 2) console.log('[VIDEO LOOP] Video duration: ' + videoloop_duration);
				videoloop.addEventListener("timeupdate", function () {
						if (!videoloop_duration) {
								videoloop_duration = (videoloop.duration - videoloop_skip_last);
								if(logit == 3) console.log('[VIDEO LOOP] Clock:' + (videoloop_duration - this.currentTime));
								if(this.currentTime >= videoloop_duration) {
									  if(logit == 2) console.log('[VIDEO LOOP] RELOOP - Duration: ' + videoloop.duration + ' time: ' + this.currentTime);
										this.currentTime = videoloop_skip_first;
								}
						} else {
								videoloop_duration = 0;
								if(logit == 2) console.log('[VIDEO LOOP] Restarted:' + videoloop.duration);
						}
				});
		} else {
			if(logit == 2) console.log('[VIDEO LOOP] Didnt find player ' + videoloop_id);
		}
	} else {
		if(logit == 2) console.log('[VIDEO LOOP] Disabled');
	}





	if(videofix_autoplay_enable) {

		if(logit == 2) console.log('[VIDEOFIX] running '+ browserName + ' mobile ' +  isMobile);

		if(browserName == "Chrome" && isMobile) {
			if(logit == 1) console.log('[VIDEOFIX] Fixed ');
			// Click a random element
			document.getElementById(videofix_autoplay_click_id).click();
			// Play video after click
			setTimeout(function(){
			    document.getElementById('video').play();
			}, 1500);
		}

	} else {
		if(logit == 3) console.log('[VIDEOFIX] Disabled');
	}




	// END JQUERY
});
